"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _components = require("../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class TranslateFactory extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleAdd", (prop, name, entity) => {
      const {
        state,
        schema,
        onChange
      } = this.props;
      const newValue = {
        [prop]: [...(state[prop] ? state[prop] : []), {
          [name]: entity.Id
        }]
      };
      return onChange(newValue);
    });
    _defineProperty(this, "handleDrop", (prop, name, entity) => {
      const {
        state,
        schema,
        onChange
      } = this.props;
      const newValue = {
        [prop]: state[prop].filter(value => value[name] !== entity[name])
      };
      return onChange(newValue);
    });
  }
  render() {
    const {
      actions,
      //schema,
      fields,
      selection,
      onChange,
      //onSubmit,
      onSelect,
      onSelectAll,
      onDelete,
      onRead,
      entity,
      state,
      errors,
      messages,
      fetching,
      fetched,
      ...rest
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", null, !!errors.length && errors.map(error => /*#__PURE__*/_react.default.createElement("div", {
      key: error.Id,
      className: "alert alert-danger alert-dismissible fade show"
    }, error.Message.length < 200 ? error.Message : "Oops, something went wrong.", /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => onRead(error.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), !!messages.length && messages.map(message => /*#__PURE__*/_react.default.createElement("div", {
      key: message.Id,
      className: "alert alert-success alert-dismissible fade show"
    }, message.Message, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => onRead(message.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), /*#__PURE__*/_react.default.createElement(_components.TranslateElementsTable, _extends({}, rest, {
      columns: fields.map(field => {
        return {
          ...field,
          editable: true
        };
      }),
      values: state,
      selection: selection,
      fetched: fetched,
      fetching: fetching,
      errors: [],
      messages: [],
      singleTo: null,
      onSelect: onSelect,
      onSelectAll: onSelectAll,
      onDelete: onDelete,
      onChange: onChange,
      entity: entity,
      actions: actions
    })));
  }
}
var _default = exports.default = TranslateFactory;
module.exports = exports.default;